module.exports = __webpack_public_path__ + "img/zengshicang.265cd713.png";